import { render, staticRenderFns } from "./SelectCategoryParent.vue?vue&type=template&id=1838c48f&"
import script from "./SelectCategoryParent.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports